import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
/*import defaultAvatar from '../../img/ava-ufo.png'; // Import the default avatar*/
// Test New Ava
// import defaultAvatar from '../../img/avatars/hzkto.jpg'; // Import the default avatar
import defaultAvatar from '../../../img/avatars/nAva.png'; // Import the default avatar
import backArrow from '../../../img/avatars/backArrow.svg';
import profile from '../../../img/avatars/profile.svg';
import chat from '../../../img/avatars/chatMsg.svg';
import CustomModal from '../CustomModal';
import profileLogo from "../../../img/profileIcon.png";
import supportLogo from "../../../img/supportLogo.png";
import settingsLogo from "../../../img/logoSettings.svg";

const Header = ({ title, back, station, available, preparing }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const avatarUrl = localStorage.getItem('avatar') || defaultAvatar;
    const isLocationProfile = location.pathname === "/profile";

    const handleBack = () => {
        switch (location.pathname) {
            case '/postreg':
                navigate('/postreg');
                break;
            case '/postreg2':
                navigate('/postreg2');
                break;
            case '/dash':
                navigate('/dash');
                break;
            case '/step5':
                navigate('/dash');
                break;
            case '/step55':
                navigate('/step5');
                break;
            case '/profile':
                navigate('/myStations');
                break;
            case '/stationControl':
                navigate('/myStations');
                break;
            default:
                navigate(-1);
        }
    };

    const handleGoUserProfile = () => {
        navigate("/profile");
    };

    const handleTgBot = () => {
        window.open("https://t.me/PSS_Support_ChargStations_bot", "_blank");
    };

    // const handleGoChat = () => {

    //     const isFeatureReady = false;
    //     if (!isFeatureReady) return; 
    //     navigate("/chat");
    // };

    const handleImageError = (event) => {
        event.target.src = defaultAvatar;
    };

    // Список страниц, на которых кнопки не должны отображаться
    const hideBackButtonPages = ['/step2', '/step3', '/pinoffer', '/pinoffer2', '/pin', '/postreg', '/dash', '/regform', '/connectComplete', '/myStations'];
    const hideAvatarPages = ['/step2', '/step3', '/pinoffer', '/pinoffer2', '/pin', '/regform', '/preprofile'];
    // const hideHeader = ['/step2', '/step3', '/pinoffer', '/pinoffer2', '/pin', '/start', '/regform'];
    const hideProfile = ['/profile', '/editProfile'];

    const handleProfile = () => {
        navigate('/profile');
    }

    const handleSupport = () => {
        window.open("https://t.me/PSS_Support_ChargStations_bot", "_blank");
    }

    const handleSettings = () => {
        navigate('/stationSettings', { state: { station } });
    }

    return (
        <>
            {isLocationProfile ? (
                <div className={styles.sectionHeader}>
                    <img
                        src={backArrow}
                        alt='back'
                        onClick={handleBack}
                        className={styles.backArrow}
                    />
                </div>
            ) : (
                <div className={styles.sectionHeader}>
                    <div className={styles.pageName}>
                        {back && (
                            <img
                                src={backArrow}
                                alt='back'
                                onClick={handleBack}
                                className={styles.backArrow}
                            />
                        )}
                        <h1 className={styles.titleText}>{title}</h1>
                    </div>
                    <div className={styles.headerSelectors}>
                        <img
                            src={profileLogo}
                            className={styles.logo}
                            alt='profileLogo'
                            onClick={handleProfile} />
                        {
                            station ? (
                                <img
                                    src={settingsLogo}
                                    className={styles.logo}
                                    alt='supportLogo'
                                    onClick={handleSettings} />
                            ) : (
                                <img
                                    src={supportLogo}
                                    className={styles.logo}
                                    alt='supportLogo'
                                    onClick={handleSupport} />
                            )}
                    </div>
                </div>
            )}
        </>

    );
};

export default Header;
// <div className={styles.sectionHeader}>
//     <div className={styles.pageName}>
//         {back && (
//             <img
//                 src={backArrow}
//                 alt='back'
//                 onClick={handleBack}
//                 className={styles.backArrow}
//             />
//         )}
//         <h1 className={styles.titleText}>{title}</h1>
//     </div>
//     <div className={styles.headerSelectors}>
//         <img
//             src={profileLogo}
//             className={styles.logo}
//             alt='profileLogo'
//             onClick={handleProfile} />
//         {
//             station ? (
//                 <img
//                     src={settingsLogo}
//                     className={styles.logo}
//                     alt='supportLogo'
//                     onClick={handleSettings} />
//             ) : (
//                 <img
//                     src={supportLogo}
//                     className={styles.logo}
//                     alt='supportLogo'
//                     onClick={handleSupport} />
//             )}
//     </div>
// </div>